import { jsx as d } from "../../../_virtual/jsx-runtime.mjs";
import _ from "react";
const r = (e = 768) => {
  const o = _.useMemo(() => `__reo_web_media_show_above_${e}`, [e]), s = _.useMemo(() => `__reo_web_media_show_below_${e}`, [e]), t = _.useMemo(() => /* @__PURE__ */ d("style", { children: `
                    .${o} {
                        display: none;
                    }

                    @media (min-width: ${e}px) {
                        .${o} {
                            display: block;
                        }
                    }

                    .${s} {
                            display: none;
                        }

                        @media (max-width: ${e - 1}px) {
                            .${s} {
                                display: block;
                            }
                        }
                ` }), [e, o, s]);
  return {
    showAboveBreakpoint: o,
    showBelowBreakpoint: s,
    styleNode: t
  };
};
export {
  r as default
};
//# sourceMappingURL=useShowControl.mjs.map
